import type { SVGProps } from "react"

export default function ChevronBullet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.47 1.23C7.33 0.04 8.97 -0.31 10.18 0.55C11.39 1.41 11.73 3.04 10.87 4.25L6.57 10.57C6.24 11.06 6.27 11.71 6.64 12.17L8.99 15.04C9.96 16.23 9.78 17.97 8.58 18.94C7.39 19.91 5.64 19.73 4.67 18.53L0.41 13.3C-0.36 12.36 -0.42 11.03 0.26 10.03L6.47 1.23Z"
        fill="#F86F3E"
      />
    </svg>
  )
}
